/*
  Remote Pods - delivery cost calculator
  Pricing model (updated):
    Every delivery: \u00a3150 vehicle running cost + fuel (round-trip miles x 30p)
                    + driver time ((round-trip miles / 50mph + loading + wheeling) x \u00a330/hr)
    Loading hour  : +1 hr driver on every option
    Wheeling hour : +1 hr driver on the two wheeled options only
    Option 1 (wheel-self) : customer has help - no paid second person
    Option 2 (wheel-help) : + second person (same hours as driver x \u00a312.50/hr)
    Option 3 (crane)      : no wheeling hour, never a second person, + \u00a3500 HIAB estimate
  Distance: one-way road miles from LL65 2FD via postcodes.io + OSRM. Round trip = 2x one-way.
*/
(function () {
  'use strict';

  var ORIGIN_POSTCODE = 'LL65 2FD';

  // --- Pricing constants (edit these to change the model) ---
  var VEHICLE_FEE    = 150;      // flat, every delivery
  var FUEL_PER_MILE  = 0.30;     // applied to ROUND-TRIP miles
  var DRIVER_HOURLY  = 30;       // GBP per hour
  var HELPER_HOURLY  = 12.50;    // GBP per hour
  var AVG_SPEED_MPH  = 50;       // used to convert miles -> driving hours
  var LOADING_HOURS  = 1;        // added to driver on every option
  var WHEELING_HOURS = 1;        // added to driver on wheeled options only
  var HIAB_FEE       = 500;      // crane option, flat estimate
  var METERS_PER_MILE = 1609.344;

  function qs(id) { return document.getElementById(id); }
  function show(el) { if (el) el.style.display = 'block'; }
  function hide(el) { if (el) el.style.display = 'none'; }
  function setText(el, t) { if (el) el.textContent = t; }
  function fmtGBP(n) {
    return '\u00a3' + Number(n).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function formatPostcode(v) {
    return (v || '').toUpperCase().replace(/\s+/g, ' ').trim();
  }
  function fetchJson(url) {
    return fetch(url).then(function (r) {
      if (!r.ok) throw new Error('Network response ' + r.status);
      return r.json();
    });
  }
  function lookupPostcode(pc) {
    return fetchJson('https://api.postcodes.io/postcodes/' + encodeURIComponent(pc)).then(function (j) {
      if (!j || !j.result) throw new Error('postcode');
      return [j.result.longitude, j.result.latitude];
    });
  }
  // road miles: main OSRM router, then a second OSRM server if the first is down
  var ROUTERS = [
    'https://router.project-osrm.org/route/v1/driving/',
    'https://routing.openstreetmap.de/routed-car/route/v1/driving/'
  ];
  function routeByRoadMiles(origin, dest, i) {
    i = i || 0;
    var u = ROUTERS[i] +
      origin[0] + ',' + origin[1] + ';' + dest[0] + ',' + dest[1] +
      '?overview=false&alternatives=false&steps=false';
    return fetchJson(u).then(function (j) {
      if (!j || !j.routes || !j.routes[0]) throw new Error('route');
      return j.routes[0].distance / METERS_PER_MILE;
    }).catch(function (e) {
      if (i + 1 < ROUTERS.length) return routeByRoadMiles(origin, dest, i + 1);
      throw e;
    });
  }

  function selectedOption() {
    var r = document.querySelector('input[name="rp-delivery-option"]:checked');
    return r ? r.value : 'wheel-self';
  }

  // Build the itemised price for a given one-way distance + option
  function priceFor(oneWayMiles, option) {
    var round = 2 * oneWayMiles;
    var drivingHrs = round / AVG_SPEED_MPH;
    var fuel = round * FUEL_PER_MILE;
    var lines = [];
    lines.push(['Vehicle running cost', VEHICLE_FEE]);
    lines.push(['Fuel (' + Math.round(round) + ' mi round trip x 30p)', fuel]);

    var driverHrs = (option === 'crane')
      ? drivingHrs + LOADING_HOURS
      : drivingHrs + LOADING_HOURS + WHEELING_HOURS;
    var driver = driverHrs * DRIVER_HOURLY;
    lines.push(['Driver (' + driverHrs.toFixed(2) + ' hrs x \u00a330)', driver]);

    var helper = 0, hiab = 0;
    if (option === 'wheel-help') {
      helper = driverHrs * HELPER_HOURLY;
      lines.push(['Second person (' + driverHrs.toFixed(2) + ' hrs x \u00a312.50)', helper]);
    }
    if (option === 'crane') {
      hiab = HIAB_FEE;
      lines.push(['HIAB crane lift (estimate)', hiab]);
    }
    var total = VEHICLE_FEE + fuel + driver + helper + hiab;
    return { lines: lines, total: total };
  }

  // Inject the option chooser + breakdown container once
  function ensureUi(postcodeEl, calcBtn, resultEl) {
    if (qs('rp-delivery-options')) return;
    var fs = document.createElement('div');
    fs.id = 'rp-delivery-options';
    fs.setAttribute('role', 'radiogroup');
    fs.innerHTML =
      '<p class="rp-opt-title">How would you like it delivered?</p>' +
      '<label class="rp-opt"><input type="radio" name="rp-delivery-option" value="wheel-self" checked>' +
        '<span><strong>Wheeled delivery</strong><small>I have two pairs of hands to help unload</small></span></label>' +
      '<label class="rp-opt"><input type="radio" name="rp-delivery-option" value="wheel-help">' +
        '<span><strong>Wheeled delivery</strong><small>I need additional help to position it</small></span></label>' +
      '<label class="rp-opt"><input type="radio" name="rp-delivery-option" value="crane">' +
        '<span><strong>Crane from roadside (HIAB)</strong><small>+\u00a3500 estimate - lifts into position off our vehicle, max 20m reach over a single-storey elevation, fence or wall</small></span></label>';
    // insert before the calculate button if possible, else before the postcode field
    var anchor = calcBtn || postcodeEl;
    anchor.parentNode.insertBefore(fs, anchor);

    // breakdown holder inside the result block, above the headline price
    if (resultEl && !qs('rp-breakdown')) {
      var bd = document.createElement('div');
      bd.id = 'rp-breakdown';
      var priceEl = qs('result-price');
      if (priceEl && priceEl.parentNode === resultEl) {
        resultEl.insertBefore(bd, priceEl);
      } else {
        resultEl.appendChild(bd);
      }
    }

    // styles
    if (!qs('rp-delivery-options-style')) {
      var st = document.createElement('style');
      st.id = 'rp-delivery-options-style';
      st.textContent =
        '#rp-delivery-options{margin:18px 0;display:grid;gap:10px;font-family:inherit}' +
        '#rp-delivery-options .rp-opt-title{font-family:inherit;font-size:12px;font-weight:600;letter-spacing:.1em;text-transform:uppercase;color:#aaa;margin:0 0 4px}' +
        '#rp-delivery-options .rp-opt{display:flex;gap:12px;align-items:flex-start;background:#1e1e1e;border:1px solid #444;border-radius:8px;padding:14px 16px;cursor:pointer;font-family:inherit;transition:border-color .15s,background .15s}' +
        '#rp-delivery-options .rp-opt:hover{border-color:#777}' +
        '#rp-delivery-options .rp-opt input{margin-top:3px;accent-color:#C62E2E;flex:none}' +
        '#rp-delivery-options .rp-opt strong{display:block;font-size:15px;font-weight:600;color:#fff}' +
        '#rp-delivery-options .rp-opt small{display:block;font-size:12.5px;color:#aaa;margin-top:2px;line-height:1.45}' +
        '#rp-delivery-options .rp-opt:has(input:checked){border-color:#C62E2E;background:#262626}' +
        '#rp-breakdown{margin:0 0 14px;font-family:inherit}' +
        '#rp-breakdown .rp-line{display:flex;justify-content:space-between;gap:16px;font-size:14px;color:#aaa;padding:6px 0;border-bottom:1px solid #333}' +
        '#rp-breakdown .rp-line span:last-child{color:#fff;font-weight:600;white-space:nowrap}';
      document.head.appendChild(st);
    }
  }

  function renderBreakdown(result, option) {
    var bd = qs('rp-breakdown');
    if (!bd) return;
    var html = '';
    // Customers only see the total. For the crane option, also show the HIAB estimate line.
    if (option === 'crane') {
      result.lines.forEach(function (l) {
        if (/HIAB/i.test(l[0])) {
          html += '<div class="rp-line"><span>' + l[0] + '</span><span>' + fmtGBP(l[1]) + '</span></div>';
        }
      });
    }
    bd.innerHTML = html;
  }

  function resetMessages(errEl, resultEl) {
    hide(errEl);
    if (resultEl) hide(resultEl);
  }
  function showError(errEl, msg) {
    setText(errEl, msg);
    show(errEl);
  }

  function bindCalculator() {
    var root = qs('postcode');
    if (!root) return;
    var container = root.closest('[data-rp2-calculator-bound]') || root.parentNode;
    if (container.getAttribute && container.getAttribute('data-rp2-calculator-bound') === 'true') {
      // already bound by an old copy; still (re)build UI
    }
    var postcodeEl = qs('postcode');
    var calcBtn    = qs('calc-btn');
    var errEl      = qs('calc-error');
    var resultEl   = qs('calc-result');
    var priceEl    = qs('result-price');
    var distLabel  = qs('route-distance-label');
    var routeWrap  = qs('route-bar-wrap');
    var routeFill  = qs('route-fill');

    ensureUi(postcodeEl, calcBtn, resultEl);

    var lastMiles = null;

    function paintRoute(miles) {
      if (distLabel) setText(distLabel, miles.toFixed(1) + ' road miles');
      if (routeWrap) show(routeWrap);
      if (routeFill) {
        var pct = Math.max(6, Math.min(100, (miles / 350) * 100));
        routeFill.style.width = pct + '%';
      }
    }

    function renderPrice() {
      if (lastMiles == null) return;
      var opt = selectedOption();
      var res = priceFor(lastMiles, opt);
      renderBreakdown(res, opt);
      // shown rounded up to the next £10, the same figure the product pages add at checkout
      if (priceEl) setText(priceEl, '\u00a3' + (Math.ceil(res.total / 10) * 10).toLocaleString('en-GB'));
      show(resultEl);
    }

    function calculate() {
      var pc = formatPostcode(postcodeEl.value);
      resetMessages(errEl, resultEl);
      if (!pc) { showError(errEl, 'Please enter your postcode.'); return; }
      if (calcBtn) { calcBtn.disabled = true; calcBtn.dataset.label = calcBtn.textContent; calcBtn.textContent = 'Calculating...'; }
      Promise.all([lookupPostcode(ORIGIN_POSTCODE), lookupPostcode(pc)])
        .then(function (pts) { return routeByRoadMiles(pts[0], pts[1]); })
        .then(function (miles) {
          lastMiles = miles;
          paintRoute(miles);
          renderPrice();
        })
        .catch(function () {
          showError(errEl, "We couldn't find that postcode. Please check it and try again, or email support@remotepods.co.uk for a quote.");
        })
        .then(function () {
          if (calcBtn) { calcBtn.disabled = false; if (calcBtn.dataset.label) calcBtn.textContent = calcBtn.dataset.label; }
        });
    }

    if (calcBtn && !calcBtn.__rpBound) { calcBtn.addEventListener('click', calculate); calcBtn.__rpBound = true; }
    if (postcodeEl && !postcodeEl.__rpBound) {
      postcodeEl.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); calculate(); } });
      postcodeEl.__rpBound = true;
    }
    // recalc live when the delivery option changes
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'rp-delivery-option') renderPrice();
    });

    if (container.setAttribute) container.setAttribute('data-rp2-calculator-bound', 'true');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindCalculator);
  } else {
    bindCalculator();
  }
})();